import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  Breadcrumbs,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
  Tooltip,
} from "InnoUI/components";
import SC from "./style";
import theme from "theme";
import AddEditRole from "./AddEditRole";
import { apiGet, apiPost } from "api/callApi";
import DeleteComponent from "../DeleteComponent";
import AssignUser from "./AssignUser";
import { Switch } from "antd";
import TimezoneConverter from "components/TimeZoneConvertor";
import InnoIcons from "@InnoIcons/";
import { showAlert } from "utils/helper";
import {
  innoTableConfig,
  innoTableConfigsecond,
  InnoTableDefaultPageSize,
} from "utils/config";

const RolesandPermission = (props) => {
  const { popupState } = props;
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [fieldData, setFieldData] = useState();
  const [rowId, setRowId] = useState();
  const currentPath = location.pathname;
  const [roleData, setRoleData] = useState([]);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openUserAssignDrawer, setOpenUserAssignDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const navigate = useNavigate();
  const [rowData, setRowData] = useState();

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Roles & Permission", href: "/admin-settings/roles-permission" },
  ];

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href);
    }
  };

  const getRole = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet("/v1/roles", false);
      setRoleData(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    getRole();
  }, []);

  const onAddDataCallback = () => {
    setOpen(true);
    setIsEditing(false);
  };

  const closeDrawer = () => {
    setOpen(false);
    setIsEditing(false);
  };

  const closeUserAssignDrawer = () => {
    setOpenUserAssignDrawer(false);
    setIsEditing(false);
  };

  const onRowClick = (data) => {
    setIsEditing(true);
    setFieldData(data);
    setRowId(data.id);
    setOpen(true);
    setRowData(data);
  };

  const handleDelete = async (roleId) => {
    try {
      const body = {
        roles: [roleId],
      };
      const response = await apiPost(`/v1/roles/delete`, body, false);
      showAlert({ title: "Success", text: response.message, icon: "success" });
      getRole();
      setOpenDeleteView(false);
    } catch (error) {
      showAlert({
        title: "Error",
        text: error?.response?.data?.message,
        icon: "error",
      });
      setOpenDeleteView(false);
      console.log(error.message);
    }
  };

  const handleArchive = async (roleId, showMessage = true) => {
    try {
      const body = {
        roles: [roleId],
        isArchive: true,
      };
      const response = await apiPost(`/v1/roles/delete`, body, false);
      if (showMessage) {
        showAlert({ title: response.message, icon: "success" });
      }
      getRole();
      setOpenDeleteView(false);
    } catch (error) {
      console.log(error.message);
    }
  };
  const onAssignUserClick = (data) => {
    setFieldData(data);
    setOpenUserAssignDrawer(true);
  };

  const handleDeleteOpenModal = (record) => {
    setRowId(record.id);
    setOpenDeleteView(true);
    setFieldData(record);
  };

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 80,
      render(value, record, index) {
        // const pageSize = innoTableConfigsecond.pageSize;
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },

    {
      title: "Role",
      dataIndex: "role",
      sorter: (a, b) => a.role.localeCompare(b.role),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["descend", "ascend"],
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Edit",
            onClick: () => onRowClick(record),
          },
          {
            id: 2,
            text: "Assign User",
            onClick: () => onAssignUserClick(record),
          },

          ...(record?.systemRole !== 1
            ? [
                {
                  id: 3,
                  text: "Delete",
                  onClick: () => handleDeleteOpenModal(record),
                },
              ]
            : []),
        ];

        return (
          <SC.PopoverContainer>
            <SC.ValueSpan>{value}</SC.ValueSpan>
            {!record.archive == 1 && (
                <Popover
                  sx={{
                    cursor: "pointer",
                  }}
                  buttonLabel={{
                    icon: (
                      <>
                        <div
                          style={{
                            width: "50px",
                            textAlign: "center",
                            justifyContent: "end",
                            display: "flex",
                            marginRight: "5px",
                          }}
                        >
                          <SC.PopoverSpan>
                            <SC.MoreVertIcon />
                          </SC.PopoverSpan>
                        </div>
                      </>
                    ),
                  }}
                  popoverContent={
                    <TableList
                      sx={{
                        borderBottom: `1px solid ${theme.colors.bordertask}`,
                      }}
                      items={menuItems || []}
                      popupState={popupState}
                    />
                  }
                />
            )}
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Role Description",
      dataIndex: "description",
      width: 600,
      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <SC.ValueSpan>{value || "No Description Provided"}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Last Modified Date & Time",
      dataIndex: "lastUpdate",
      width: 250,

      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <SC.ValueSpan>
              <TimezoneConverter time={value} />
            </SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Last Modified By",
      dataIndex: "lastUpdatedByName",
      width: 250,
      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Archive",
      dataIndex: "archive",
      align: "center",
      render: (value, record) =>
        record?.systemRole !== 1 ? (
          <Switch
            checked={value}
            onChange={(checked) => handleArchive(record.id, false)}
            style={{
              transform: "scale(0.7)",
              backgroundColor: value ? `${theme.colors.themeColor}` : undefined,
              borderColor: value ? `${theme.colors.themeColor}` : undefined,
            }}
          />
        ) : (
          <Tooltip title={"System Role"} placement="top-start" arrow>
            <InnoIcons.GppMaybeIcon sx={{ color: theme.colors.themeColor }} />
          </Tooltip>
        ),
    },
  ];
  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: true,
    search: true,
    action: false,
    sno: false,
    divBorder: true,
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    searchPlaceholder: "Search by Role and Description",
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={handleBreadcrumbClick}
      />
      <SC.BodyContainer>
        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            padding={"8px 8px 8px 8px"}
            column={subColumnData}
            data={roleData}
            tableKey={"Role"}
            ComponnentName={"Roles & Permissions"}
            searchKeys={["role", "description"]}
            onAddDataCallback={onAddDataCallback}
            onRowClickCallback={onRowClick}
            loading={isLoading}
          />
        </SC.Container>
      </SC.BodyContainer>

      <DeleteComponent
        title={"Delete Role"}
        messageData={`Are you sure you want to delete role ${
          fieldData?.role || ""
        }?`}
        setOpenDeleteView={setOpenDeleteView}
        openDeleteView={openDeleteView}
        handleDelete={() => handleDelete(rowId)}
        handleArchive={() => setOpenDeleteView(false)}
        firstButtontext={"Cancel"}
      />

      {openUserAssignDrawer && (
        <DetailDrawer
          open={openUserAssignDrawer}
          onClose={closeUserAssignDrawer}
          width={"1100px"}
          children={
            <AssignUser
              userdata={fieldData}
              onClose={closeUserAssignDrawer}
              //fetchData={getAlldata}
            />
          }
        />
      )}

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <AddEditRole
              roledata={fieldData}
              onClose={closeDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              fetchData={getRole}
              rowId={rowId}
              rowData={rowData}
            />
          }
        ></DetailDrawer>
      )}
    </>
  );
};

export default RolesandPermission;
